var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Link',{attrs:{"text":_vm.text,"type":_vm.isPrimary ? _vm.LinkType.Primary : _vm.LinkType.NoStyle,"url":_vm.url},on:{"click":function($event){return _vm.toggleNavigation()}}})}
var staticRenderFns = []

export { render, staticRenderFns }